import { Reveal } from './Reveal';
import { LANDING_SOCIAL_METRICS, LANDING_SOCIAL_PROOF_LINHA } from '../../domain/landingContent';

/** Barra de prova social — rede Espetos + métricas. */
export function LandingSocialProof() {
  return (
    <section className="mx-auto max-w-6xl px-4 py-16 sm:px-6 sm:py-20">
      <Reveal className="text-center">
        <p className="text-sm text-slate-400">{LANDING_SOCIAL_PROOF_LINHA}</p>
      </Reveal>

      <Reveal delay={0.12}>
        <div className="mt-10 grid grid-cols-1 gap-6 border-t border-white/[0.06] pt-10 sm:grid-cols-3 sm:gap-4">
          {LANDING_SOCIAL_METRICS.map(({ valor, label }) => (
            <div key={label} className="min-w-0 text-center">
              <p className="truncate text-2xl font-black tabular-nums tracking-tight text-white sm:text-3xl">{valor}</p>
              <p className="mt-1 break-words text-xs text-slate-500">{label}</p>
            </div>
          ))}
        </div>
      </Reveal>
    </section>
  );
}
